import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  ReactDubaiFrontendIcon,
  ReactDubaiUIkitsIcon,
  ReactDubaiToolsIcon,
  ReactDubaiDatabaseIcon,
} from "../../../app-constants";

const StackItem = [
  {
    icon: ReactDubaiFrontendIcon,
    title: "Frontend",
    description: "React, Typescript, JavaScript, Bootstrap",
  },
  {
    icon: ReactDubaiUIkitsIcon,
    title: "UI Kits",
    description: "Nativebase, Ignite UI, UI kitten, React Native Elements",
  },
  {
    icon: ReactDubaiToolsIcon,
    title: "Testing Tools",
    description: "Jest, Enzyme, Detox",
  },
  {
    icon: ReactDubaiDatabaseIcon,
    title: "Databases",
    description: "SQLite, Firebase, Pounchdb, Realm, AWS, Azure",
  },
];

function Technology(props) {
  return (
    <div className="technoloy_sec p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="">
            <div className="example" data-text="Tech">
              <h2>Unlocking Innovation with Our React Native App Kit</h2>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1"
          >
            <p>
              TekRevol utilizes the latest technology to develop spectacular
              React Native mobile apps. Using this powerful stack, we bring
              creative and modern solutions in the digital world.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={11} xxl={11} className="m-auto">
            <div className="technology_main">
              {StackItem.map((item, index) => (
                <div className="technology_item">
                  <div className="svg_icon">{item.icon}</div>
                  <h6>{item.title}</h6>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Technology;
